import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import apiServices from "../../services/apiServices";

// First, create the thunk
export const fetchAllusers = createAsyncThunk(
  "user_state/fetchAlluser",
  async () => {
    const response = await apiServices.get("users");

    return response.data.data;
  }
);
export const adduser = createAsyncThunk(
  "user_state/adduser",
  async (data, thunkAPI) => {
    console.log("user data", data);
    try {
      const response = await apiServices.post("signup", data);
      return response.data.data;
    } catch (error) {
      console.log("Add user error", error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const editUser = createAsyncThunk(
  "user_state/editUser",
  async (data) => {
    console.log("user data", data);
    const response = await apiServices.put("user/" + data.id, data);
    console.log(response.data.data);
    return response.data.data;
  }
);
export const editUserPassword = createAsyncThunk(
  "user_state/editUserPassword",
  async (data) => {
    console.log("user data", data);
    const response = await apiServices.put("user/password-change/" + data.id, data);
    console.log(response.data.data);
    return response.data.data;
  }
);

export const userLogin = createAsyncThunk(
  "user_state/userLogin",
  async (data, thunkAPI) => {
    try {
      const result = await apiServices.post("login", data) //.catch(x=>console.log("error=> thunk ", x.response.data));
       

      return result.data
    } catch (error) {
      console.log("error login ", error.response.data.data)
      return thunkAPI.rejectWithValue(error.response.data.data);
    }
  }
);

const initialState = {
  auth: {},
  users: [],
  error: "",
  user: {
    email: "",
    password: "",
    role: "",
    accessToken: "",
    isLogin: false,
  },
};

let userSlice = createSlice({
  name: "user_state",
  initialState,
  reducers: {
    // insert actions here

    //action 2
    resetErrorMessages: function (state, action) {
      state.errorMessage = null;
      state.validationError = null;
      state.successMessage = null;
    },
    logOut: function (state, action) {
      state.errorMessage = null;
      state.validationError = null;
      state.successMessage = null;
      state.isLogin = false
      delete apiServices.defaults.headers.Authorization
      localStorage.removeItem("JWT-TOKEN")
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchAllusers.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchAllusers.fulfilled, (state, action) => {
      // Add user to the state array
      console.log("user : ", action.payload);
      let users = [];
      action.payload &&
        action.payload.map((x) => {
          let user = {
            id: x._id,
            userName: x.userName,
            email: x.email,
            password: x.password,
            role: x.role,
            accessToken: x.accessToken,
            registerDate: new Date(x.registerDate).toLocaleDateString(),
            status: x.status,
            userId:x.userId
          };

          return users.push(user);
        });
      state.users = users;
      state.loading = false;
    });
    builder.addCase(fetchAllusers.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in fetching users";
    });

    // add all user
    builder.addCase(adduser.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(adduser.fulfilled, (state, action) => {
      // Add user to the state array
      console.log("action : ", action.payload);

      let user = {
        Id: action.payload._id,
        userId: action.payload.userId,
        email: action.payload.email,
        password: action.payload.password,
        role: action.payload.role,
        accessToken: action.payload.accessToken,
        registerDate: action.payload.registerDate,
        userName: action.payload.userName,
        status: action.payload.status,
      };
      state.users = [...state.users, user];
      state.loading = false;
      state.successMessage = "New user created";
    });
    builder.addCase(adduser.rejected, (state, action) => {
      state.loading = false;
      state.validationError = null;
      state.errorMessage = null;
      state.successMessage = null;

      if(!action.payload.response) return state.errorMessage = "Cannot save new user, server error"

      if (action.payload.response.status === 400) {
        //bad request
        if (action.payload.response.data.validationError)
              state.validationError = action.payload.response.data.validationError;
            
      } else
        state.errorMessage =
          JSON.stringify(action.payload.response.data.error) ||
          "Oops !, server error in adding user";
      console.log("add user action", action);
    });
    // add all user
    builder.addCase(editUser.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(editUser.fulfilled, (state, action) => {
      // Add user to the state array
      console.log("action : ", action.payload);

      let user = {
        email: action.payload.email,
        password: action.payload.password,
        role: action.payload.role,
        registerDate: action.payload.registerDate,
        userName: action.payload.userName,
        
        // accessToken: action.payload.accessToken,
        status: action.payload.status,
      };
      // state.users = [...state.users, user];
      state.loading = false;
      state.successMessage = "User info updated success";
    });
    builder.addCase(editUser.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in editUser ";
      console.log(state.errorMessage);
    });

    builder.addCase(editUserPassword.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(editUserPassword.fulfilled, (state, action) => {
      // Add user to the state array
      console.log("action : ", action.payload);

      let user = {
        email: action.payload.email,
        password: action.payload.password,
        role: action.payload.role,
        registerDate: action.payload.registerDate,
        // accessToken: action.payload.accessToken,
        status: action.payload.status,
      };
      // state.users = [...state.users, user];
      state.loading = false;
    });
    builder.addCase(editUserPassword.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in editUserPassword ";
      console.log(state.errorMessage);
    });

    builder.addCase(userLogin.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(userLogin.fulfilled, (state, action) => {
      console.log("action : ", action.payload);
      state.loading = false;
      state.user = action.payload.data;
      state.isLogin = true;

      localStorage.setItem("JWT-TOKEN", action.payload.accessToken)
      
        apiServices.defaults.headers = {
          Authorization: action.payload.accessToken
        }
        
      
    });
    builder.addCase(userLogin.rejected, (state, action) => {
      state.loading = false;
      state.isLogin = false;

      console.log("login action ", action);
      state.errorMessage = action.payload || "Oops !, server error in login";
    });
  },
});

export const { resetErrorMessages , logOut } = userSlice.actions;

export default userSlice.reducer;
